<template>
    <mounting-portal mount-to="#portalvue-podcast">
        <div class="podcasts-slick mb-60px">
            <div v-for="episode, episodeIndex in podcasts"
                :key="episodeIndex"
                class="relative w-full bg-black md:bg-gradient-to-b md:from-black md:via-gray-900 md:to-black md:px-5 mb-4">

                <div class="w-full container md:mx-auto">
                    <div class="flex">
                        <div class="w-full container mx-auto flex flex-col md:flex-row-reverse" style="min-height: 380px;">
                            <div class="w-full md:w-1/2 mt-10">
                                <a href="/podcast" class="flex flex-col md:flex-row-reverse items-center md:justify-start space-x-1">
                                    <img class="w-12 mb-2 md:mb-0 md:ml-4" :src="ASSET_LINK('/svg/icon-podcast.svg')" />
                                    <span class="text-gray-300 text-xl mt-3 text-waheed">މިހާރު ޕޮޑްކާސްޓް</span>
                                </a>

                                <div class="flex flex-col w-full items-center md:items-end justify-center space-y-4 text-center md:text-right px-4 mt-10 md:pl-12">
                                    <h4 class="text-gray-200 text-3xl text-waheed">{{ episode.podcast.name }}: {{ episode.episode_name }}</h4>
                                    <p class="text-gray-300 text-xl break-normal text-waheed leading-10">
                                        {{ episode.episode_description }}</p>
                                </div>

                                <div class="w-full flex items-center md:justify-end justify-center space-x-2 mt-10 mb-16">
                                    <div v-if="null !== episode.spotify"
                                        class="flex justify-center w-10">
                                        <a :href="episode.spotify + '?ref=mhr-hme-podcastbanner'" target="_blank" title="Spotify">
                                            <img class="w-12 h-12" :src="ASSET_LINK('/svg/spotify-logo.svg')" alt="Spotify Logo" />
                                        </a>
                                    </div>

                                    <div v-if="null !== episode.itunes"
                                        class="flex justify-center w-10">
                                        <a :href="episode.itunes + '?ref=mhr-hme-podcastbanner'" target="_blank" title="Apple Podcasts">
                                            <img class="w-8 h-8" :src="ASSET_LINK('/svg/itunes-logo.svg')" alt="Apple Podcasts Logo" />
                                        </a>
                                    </div>

                                    <div v-if="null !== episode.soundcloud"
                                        class="flex justify-center w-10">
                                        <a :href="episode.soundcloud + '?ref=mhr-hme-podcastbanner'" target="_blank" title="SoundCloud">
                                            <img class="w-8 h-8" :src="ASSET_LINK('/svg/soundcloud.svg')"  alt="SoundCloud Logo" />
                                        </a>
                                    </div>

                                    <div v-if="null !== episode.google"
                                        class="flex justify-center w-10">
                                        <a :href="episode.google + '?ref=mhr-hme-podcastbanner'" target="_blank" title="Google Podcasts">
                                            <img class="w-8 h-8" :src="ASSET_LINK('/svg/google-podcasts.svg')" alt="Google Podcasts Logo" />
                                        </a>
                                    </div>

                                    <div v-if="null !== episode.anchor"
                                        class="flex justify-center w-10">
                                        <a :href="episode.anchor + '?ref=mhr-hme-podcastbanner'" target="_blank" title="Anchor FM">
                                            <img class="w-8 h-8" :src="ASSET_LINK('/svg/anchorfm.svg')" alt="Anchor FM Logo" />
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class="w-full md:w-1/2">
                                <div class="relative md:h-full">
                                    <img class="object-cover h-full w-full md:rounded-r-full" :src="episode.cover_art.small" />

                                    <div v-if="episodeIndex !== nowPlaying" 
                                        class="absolute w-full h-full top-0 flex justify-center items-start -mt-6 md:mt-0 md:ml-8 md:items-center md:justify-end">
                                        <button
                                            v-on:click="startPlaying(episodeIndex)"
                                            class="hover:scale-110 text-white transform transition duration-300">
                                            <svg id="Group_1" data-name="Group 1" xmlns="http://www.w3.org/2000/svg" class="w-16 h-16" viewBox="0 0 50 50">
                                                <path id="Subtraction_1" data-name="Subtraction 1" d="M20.534,37.374a1.774,1.774,0,0,1-.817-.2,1.813,1.813,0,0,1-.967-1.611V17.437a1.81,1.81,0,0,1,.967-1.61,1.774,1.774,0,0,1,.817-.2,1.756,1.756,0,0,1,1.035.336l12.493,9.063a1.828,1.828,0,0,1,0,2.95L21.57,37.039A1.759,1.759,0,0,1,20.534,37.374Z" transform="translate(-0.75 -1.626)"/>
                                                <path id="play" d="M50,25A25,25,0,1,1,25,0,25,25,0,0,1,50,25ZM21.219,15.916a1.563,1.563,0,0,0-2.469,1.272V32.813a1.562,1.562,0,0,0,2.469,1.272l10.938-7.812a1.562,1.562,0,0,0,0-2.544L21.219,15.916Z" transform="translate(0 0)" fill="currentColor"/>
                                            </svg>

                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="episodeIndex === nowPlaying"
                        class="absolute w-full left-0 bottom-0">
                        <div class="container mx-auto bg-black py-8 opacity-75">
                            <vue-plyr>
                                <audio controls playsinline autoplay>
                                    <source :src="episode.audio_src" type="audio/mpeg" />
                                </audio>
                            </vue-plyr>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mounting-portal>
</template>

<script>
export default {
    props: ['podcasts'],
    data() {
        return {
            nowPlaying: null
        }
    },
    computed: {

    },
    methods: {
        startPlaying(index) {
            this.nowPlaying = index

            axios.post('podcast/play', {
                episode: this.podcasts[index].id
            }).then(resp => {
                // console.log(resp)
            }).catch(e => {
                console.error(e)
            })
        }
    }
}
</script>